module.exports = __webpack_public_path__ + "static/img/choice-3.05a01d7.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/choice-3.jpeg
// module id = uUfc
// module chunks = 73